/** @format */

import { useState } from "react";

function TrunckText({ text, maxLength }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const displayText = isExpanded ? text : text.substring(0, maxLength) + "...";

  return (
    <div>
      <p className='text-slate-600 text-justify leading-relaxed'>
        {displayText}
      </p>
      {text.length > maxLength && (
        <button
          className='mt-2 text-blue-500 hover:underline'
          onClick={toggleExpand}
        >
          {isExpanded ? "Voir moins" : "Voir plus"}
        </button>
      )}
    </div>
  );
}

export default TrunckText;
